import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';

const ReceiptIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          d="M7 8.00018C7 7.58597 7.33579 7.25018 7.75 7.25018H12.25C12.6642 7.25018 13 7.58597 13 8.00018C13 8.4144 12.6642 8.75018 12.25 8.75018H7.75C7.33579 8.75018 7 8.4144 7 8.00018Z"
          fill="#006DFF"
        />
        <path
          d="M7.75 10.2502C7.33579 10.2502 7 10.586 7 11.0002C7 11.4144 7.33579 11.7502 7.75 11.7502H16.25C16.6642 11.7502 17 11.4144 17 11.0002C17 10.586 16.6642 10.2502 16.25 10.2502H7.75Z"
          fill="#006DFF"
        />
        <path
          d="M7 14.0002C7 13.586 7.33579 13.2502 7.75 13.2502H16.25C16.6642 13.2502 17 13.586 17 14.0002C17 14.4144 16.6642 14.7502 16.25 14.7502H7.75C7.33579 14.7502 7 14.4144 7 14.0002Z"
          fill="#006DFF"
        />
        <path
          d="M7.75 16.2502C7.33579 16.2502 7 16.586 7 17.0002C7 17.4144 7.33579 17.7502 7.75 17.7502H10.25C10.6642 17.7502 11 17.4144 11 17.0002C11 16.586 10.6642 16.2502 10.25 16.2502H7.75Z"
          fill="#006DFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.6847 2.00009C14.7445 1.99925 15.5493 1.99862 16.2881 2.30466C17.0269 2.61069 17.5955 3.1802 18.3444 3.9302L19.07 4.6558C19.82 5.40464 20.3895 5.97325 20.6955 6.71208C21.0016 7.45091 21.0009 8.25568 21.0001 9.31553L21 17.066C21.0001 17.9525 21.0001 18.7163 20.9179 19.328C20.8297 19.9835 20.631 20.6118 20.1213 21.1215C19.6117 21.6312 18.9833 21.8299 18.3278 21.918C17.7161 22.0003 16.9523 22.0002 16.0658 22.0002H7.9342C7.0477 22.0002 6.28388 22.0003 5.67221 21.918C5.0167 21.8299 4.38835 21.6312 3.87869 21.1215C3.36902 20.6118 3.17028 19.9835 3.08215 19.328C2.99991 18.7163 2.99995 17.9525 3 17.066V6.93437C2.99995 6.04787 2.99991 5.28405 3.08215 4.67238C3.17028 4.01687 3.36902 3.38852 3.87869 2.87885C4.38835 2.36919 5.0167 2.17045 5.67221 2.08231C6.28387 2.00008 7.04769 2.00012 7.93418 2.00017L13.6847 2.00009ZM13.9999 4.00141C13.854 4.0005 13.6931 4.00017 13.5147 4.00017H8.00001C7.02893 4.00017 6.40122 4.0023 5.93871 4.06448C5.50497 4.12279 5.36902 4.21694 5.2929 4.29307C5.21678 4.36919 5.12263 4.50514 5.06431 4.93888C5.00213 5.40138 5.00001 6.02909 5.00001 7.00017V17.0002C5.00001 17.9713 5.00213 18.599 5.06431 19.0615C5.12263 19.4952 5.21678 19.6312 5.2929 19.7073C5.36902 19.7834 5.50497 19.8776 5.93871 19.9359C6.40122 19.9981 7.02893 20.0002 8.00001 20.0002H16C16.9711 20.0002 17.5988 19.9981 18.0613 19.9359C18.495 19.8776 18.631 19.7834 18.7071 19.7073C18.7832 19.6312 18.8774 19.4952 18.9357 19.0615C18.9979 18.599 19 17.9713 19 17.0002V9.48546C19 9.3071 18.9997 9.14609 18.9988 9.00018H16.9999C15.3431 9.00018 13.9999 7.65704 13.9999 6.00018V4.00141ZM15.9999 4.45971V6.00018C15.9999 6.55247 16.4477 7.00018 16.9999 7.00018H18.5404C18.346 6.7679 18.0412 6.45562 17.5355 5.94992L17.0503 5.46464C16.5445 4.9589 16.2322 4.6541 15.9999 4.45971Z"
          fill="#006DFF"
        />
      </svg>
    );
  }
);

export default ReceiptIcon;
